import ProductSimpleView from './ProductSimpleView'

export default ProductSimpleView
